import { connect } from 'react-redux';
import AddressesSection from '../components/AddressesSection';
import { State } from '../../../../reducer';
import { getAddressesStateSelector } from '../selectors';
import { closeEditModal, openEditModal, editCustomerAddresses, openAddModal, closeAddModal, addCustomerAddresses } from '../actions';


const mapStateToProps = (state: State) => ({
    addressesState: getAddressesStateSelector(state),
});

export default connect(
    mapStateToProps,
    {
        openEditModal,
        closeEditModal,
        openAddModal,
        closeAddModal,
        editCustomerAddresses,
        addCustomerAddresses,
    }
)
(AddressesSection);
